// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 股票指标试用服务信息 GET /quote-index/subscription/info */
export async function quoteIndexSubscriptionInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.quoteIndexSubscriptionInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultQuoteIndexSubscriptionInfoResp>('/quote-index/subscription/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 股票指标试用 POST /quote-index/subscription/open */
export async function quoteIndexSubscriptionOpenUsingPOST(
  body: API.QuoteIndexSubscriptionOpenReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/quote-index/subscription/open', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
